/**
 * Boiler Plate module
 *
 * Not technically a module, it exists outside of the Modules loop.
 * If content is set on a Page only, this block will be rendered
 * right below the footer.
 *
 * Comp: https://cl.ly/75a3e9e52b16/Image%202019-11-21%20at%209.34.27%20AM.png
 */

//  Deps
import get from "lodash.get";
import { colors, gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { textStyles } from "~/styleguide/typography";
import { createComponent, FelaComponent } from "react-fela";

// Context
import { useContext } from "react";
import { DataContext } from "~/context/content";
import globalData from "~/data/site-data.json";

// Components
import { ContentMaxWidth } from "~/components/layout/max-width";

export default function BoilerplateModule() {
    const globalFields = get(globalData, "data");
    const pageData = useContext(DataContext);
    const page = get(pageData, "listing_page", pageData);

    // Get the flag on a per-page basis to determine if the boilerplate should be displayed
    const showBoilerplate = get(page, "acf.show_boilerplate");
    const useGlobal = get(page, "acf.boilerplate_global_content");

    const dataTarget = useGlobal ? globalFields : page;

    if (!showBoilerplate) return null;

    // Grab boilerplate content from global data
    const heading = get(dataTarget, "acf.boilerplate_heading");
    const subheading = get(dataTarget, "acf.boilerplate_subheading");
    const copy = get(dataTarget, "acf.boilerplate_copy");

    // Don't render anything if none of the values are set
    if (!heading && !subheading && !copy) return null;

    return (
        <Container>
            <ContentMaxWidth extend={{ maxWidth: 850 }}>
                <FelaComponent style={headingWrapperStyles}>
                    {/* Heading */}
                    <FelaComponent
                        as="h5"
                        style={{ ...textStyles.paragraphLarge }}
                    >
                        <strong dangerouslySetInnerHTML={{ __html: heading }} />
                    </FelaComponent>

                    {/* Subheading */}
                    {subheading && 
                        <FelaComponent
                            as="h6"
                            style={{ ...textStyles.paragraphLarge }}
                        >
                            <span dangerouslySetInnerHTML={{ __html: subheading }} />
                        </FelaComponent>
                    }
                </FelaComponent>

                {/* Copy content */}
                {copy && <FelaComponent
                        as="p"
                        style={{
                            marginTop: 20,
                            ...textStyles.paragraphSmall,
                            lineHeight: "24px"
                        }}
                    >
                        <span dangerouslySetInnerHTML={{ __html: copy }} />
                    </FelaComponent>
                }
            </ContentMaxWidth>
        </Container>
    );
}

const Container = createComponent(() => ({
    background: colors.lightGrey,
    //taken from comps
    paddingTop: 87,
    paddingBottom: 87,
    extend: [fluid("paddingH", gutters.default)],
    minWidthMobile: {
        extend: [fluid("paddingV", gutters.vertical)]
    }
}));

const headingWrapperStyles = {
    textAlign: "center",
    marginBottom: 45
};
